import { render, staticRenderFns } from "./MaterialGroupConfigEdit.vue?vue&type=template&id=e177d2e4&scoped=true&"
import script from "./MaterialGroupConfigEdit.vue?vue&type=script&lang=js&"
export * from "./MaterialGroupConfigEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e177d2e4",
  null
  
)

export default component.exports